// Constantes statuts métier centralisées (FR)
// Source unique pour tags, badges, sélecteurs et libellés.

// ─── Contrats ───────────────────────────────────────────────────────────
export const CONTRAT_STATUTS = {
    actif: { code: 'actif', label: 'Actif', color: 'green' },
    expire: { code: 'expire', label: 'Expiré', color: 'red' },
    suspendu: { code: 'suspendu', label: 'Suspendu', color: 'orange' },
    resilie: { code: 'resilie', label: 'Résilié', color: 'volcano' },
    renouvele: { code: 'renouvele', label: 'Renouvelé', color: 'blue' },
};
export const getContratStatutLabel = (code) => CONTRAT_STATUTS[code]?.label || code || '—';
export const getContratStatutColor = (code) => CONTRAT_STATUTS[code]?.color || 'default';

// ─── Sinistres ──────────────────────────────────────────────────────────
export const SINISTRE_STATUTS = {
    declare: { code: 'declare', label: 'Déclaré', color: 'blue' },
    en_cours: { code: 'en_cours', label: "En cours d'instruction", color: 'orange' },
    regle: { code: 'regle', label: 'Réglé (indemnisé)', color: 'green' },
    rejete: { code: 'rejete', label: 'Rejeté', color: 'red' },
};
export const getSinistreStatutLabel = (code) => SINISTRE_STATUTS[code]?.label || code || '—';
export const getSinistreStatutColor = (code) => SINISTRE_STATUTS[code]?.color || 'default';

// ─── Règlements (état d'avancement du paiement par rapport à la prime) ──
// Calculé à partir de totalVerse / primeTTC.
export const REGLEMENT_ETATS = {
    paye: { code: 'paye', label: 'Payé', color: 'green', hex: '#52c41a' },
    partiel: { code: 'partiel', label: 'Partiel', color: 'orange', hex: '#fa8c16' },
    impaye: { code: 'impaye', label: 'Impayé', color: 'red', hex: '#ff4d4f' },
};
export const getReglementEtat = (totalVerse, primeTTC) => {
    if (!primeTTC) return REGLEMENT_ETATS.impaye;
    const percent = Math.round(((totalVerse || 0) / primeTTC) * 100);
    if (percent >= 100) return REGLEMENT_ETATS.paye;
    if (percent > 0) return REGLEMENT_ETATS.partiel;
    return REGLEMENT_ETATS.impaye;
};

// ─── Modes de paiement ──────────────────────────────────────────────────
export const MOYENS_PAIEMENT = {
    especes: { code: 'especes', label: 'Espèces', color: '#52c41a' },
    cheque: { code: 'cheque', label: 'Chèque', color: '#1890ff' },
    virement: { code: 'virement', label: 'Virement', color: '#722ed1' },
    mobile_money: { code: 'mobile_money', label: 'Mobile Money', color: '#fa8c16' },
};
export const getMoyenPaiementLabel = (code) => MOYENS_PAIEMENT[code]?.label || code || '—';
